import React from 'react'
import styles from './SectionMap.module.css';

const SectionMap = () => {
  return (
    <div className={styles.section}><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.356213553762!2d-79.85657673152127!3d0.8720400610074971!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fd4eceab416bc53%3A0x47c34842c936638a!2sHotel%20Torre%20Eiffel%20Atacames!5e0!3m2!1ses!2sec!4v1737665406963!5m2!1ses!2sec" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
  )
}

export default SectionMap